import React from 'react';
import {FormHelperText, InputLabel, Select, Tooltip} from '@mui/material';
import EditCloneDeleteMenu from "../Menus/EditCloneDeleteMenu";
import {useSelector} from "react-redux";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";


export const DataPointAttributeGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',
        description: '',
        sortable: true,
        width: 60,
        hide: false,
    },
    {
        field: 'mcode',
        headerName: 'Code',
        description: '',
        sortable: true,
        editable: true,
        hide: true,
        // editable: true,
        width: 200,
    },
    {
        field: 'name',
        headerName: 'Name',
        description: '',
        sortable: false,
        editable: true,
        width: 500,
    },
    {
        field: 'category',
        headerName: 'Category',
        description: '',
        sortable: true,
        editable: true,
        hide: false,
        width: 150,
    },

    {
        field: 'description',
        headerName: 'Description',
        description: '',
        sortable: false,
        editable: true,
        width: 1000,
    },
];
